import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useApplication } from '../context/ApplicationContext';

const { FiChevronDown, FiAlertCircle } = FiIcons;

function SelectField({
  label,
  value,
  onChange,
  options,
  placeholder = 'Select an option',
  required = false,
  error,
  icon,
  disabled = false,
  fieldName,
  ...props
}) {
  const { state } = useApplication();
  const { errors } = state;
  
  const fieldError = error || (fieldName && errors[fieldName]);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className="space-y-2 w-full max-w-full">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative w-full">
        {icon && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 z-10">
            <SafeIcon icon={icon} className="w-4 h-4 sm:w-5 sm:h-5" />
          </div>
        )}
        <select
          value={value}
          onChange={handleChange}
          required={required}
          disabled={disabled}
          className={`
            w-full px-3 sm:px-4 py-2 sm:py-3 border rounded-lg focus:ring-2 focus:ring-agric-primary focus:border-agric-primary transition-colors duration-200 appearance-none bg-white text-sm sm:text-base
            ${fieldError ? 'border-red-500' : 'border-gray-300'}
            ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'cursor-pointer'}
            ${icon ? 'pl-10 sm:pl-12' : ''}
          `}
          {...props}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
          <SafeIcon icon={FiChevronDown} className="w-4 h-4 sm:w-5 sm:h-5" />
        </div>
      </div>
      {fieldError && (
        <div className="flex items-center gap-2 text-red-600 text-sm">
          <SafeIcon icon={FiAlertCircle} className="w-4 h-4 flex-shrink-0" />
          <span className="break-words">{fieldError}</span>
        </div>
      )}
    </div>
  );
}

export default SelectField;